import React, { useState } from "react";
import env from "react-dotenv";
import axios from 'axios';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Alert
} from "react-bootstrap";
import { AppContext } from "../../contexts/AppContext";

export default function ResetPassword() {
  const {notify} = React.useContext(AppContext);
  const [formData, setFormData] = useState({
    email: "",
    dob: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors("");
    setSuccess(false);

    if (formData.password !== formData.confirmPassword) {
      notify("Passwords do not match!", 'error');
      return;
    }

    try {
      const { data } = await axios.post(`${env.REACT_APP_API_URL}/user/reset-password`, formData );
      notify("🔒 Your password has been updated successfully.", 'success');
      setTimeout(() => {
        window.location.href = "/";
      },6000)
    } catch (error) {
      console.log(error.response.data.error);
      notify(error.response.data.error, 'error');
      setSuccess(false);
    }
  };

  return (
    <>
      {/* <section className="py-5 py-md-3 py-lg-8 py-xl-10"> */}
      <section className="py-6">
        <Container>
          <div className="row justify-content-md-center">
            <div className="col-12 col-md-6 col-lg-5">
              <div className="card p-3">
              <h6>Reset Password</h6>
              {errors && <Alert variant="danger">{errors}</Alert>}
              {success && <Alert variant="success">Form submitted successfully!</Alert>}

              <Form onSubmit={handleSubmit}>
                {/* Email */}
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                {/* DOB */}
                <Form.Group className="mb-3" controlId="dob">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                {/* Password */}
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,16}$"
                    required
                  />
                  <p style={{ color: '#0f4f96',
                    fontSize: '0.7rem',
                    paddingTop: '5px',
                    fontWeight: 400,
                    lineHeight: 1.4,
                    marginBottom: '0.25rem' }}>
                      Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character. The maximum password character length cannot exceed 16 characters
                  </p> 
                </Form.Group>

                {/* Confirm Password */}
                <Form.Group className="mb-3" controlId="confirmPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                
                <a href={`${process.env.PUBLIC_URL}/`}>« Back to Login</a>
                <Button variant="primary" type="submit" className="w-100 mt-2">
                  Submit
                </Button>
              </Form>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}